




import {Component, Ref, Vue} from "vue-property-decorator";
import OriginatorRule from "@/pages/Pages/Rules/OriginatorRule.vue";
import {MsgTransports} from "@/store/types";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {OriginatorRule}})
export default class SmsOriginatorRule extends Vue{
  @Ref('originatorRule') originatorRule: any;
  private smsTransport: MsgTransports = MsgTransports.SMS

  beforeRouteLeave(to:any, from:any, next:any) {
    this.originatorRule.beforeLeave(to,from,next)
  }
}
